<template>
  <Header />
  <Nav />
  <router-view></router-view>
  <Footer />
</template>


<script>
import Header from '@/components/Home/Header.vue';
import Nav from '@/components/Home/Nav.vue';
import Footer from '@/components/Home/Footer.vue';
// import store from "@/store/index";
// import moment from "moment";

export default {
  name: 'HomeView',
  components: {
    Header,
    Nav,
    Footer,
  },
  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },

  // mounted() { this.currentTime = moment.utc().valueOf() },
  // data() {
  //   return {
  //     currentTime: moment.utc().valueOf()
  //   }
  // },

  // computed: {
  //   ExpiredTime() {
  //     // EXPIRED TIME = BACKEND HOUR TIME EXPIRY FROM LOGGING IN -  50 MINUTES
  //                 //  = 10 MINUTES FROM NOW
  //     return moment(store.getters.StateExpiresAt).utc().subtract(50, "minutes").valueOf()
  //   },
  // },

  // watch: {
  //   currentTime(newValue) {
  //     // IF CURRENT TIME EXCEEDS EXPIRATION TIME , REFRESH TOKEN
  //     if (newValue > this.ExpiredTime) {
  //       store.dispatch("refreshToken", {
  //         refreshtoken: store.getters.StateRefreshToken
  //       })
  //     }
  //   },
    
  // }

}

</script>
